import { Button, SelectColumnsButton, TopToolbar, usePermissions } from "react-admin";
import AddIcon from "@mui/icons-material/Add";
import UploadFileIcon from "@mui/icons-material/UploadFile";

const CreateOnlyAction = ({
  createHandler,
  uploadHandler,
  createPermission,
}) => {
  const { permissions } = usePermissions();
  return (
    <TopToolbar
      sx={{
        minHeight: "54px !important",
        mb: 1,
        "& .MuiButtonBase-root": {
          border: "0.1rem solid",
        },
      }}
    >
      <SelectColumnsButton />
      {(permissions.administrator || permissions[createPermission]) &&
      createHandler ? (
        <Button
          startIcon={<AddIcon />}
          label="ra.action.create"
          sx={{ width: "fit-content" }}
          onClick={createHandler}
        />
      ) : null}
      {uploadHandler ? (
        <Button
          startIcon={<UploadFileIcon />}
          label="mine.label.upload"
          sx={{ width: "fit-content" }}
          onClick={uploadHandler}
        />
      ) : null}
    </TopToolbar>
  );
};

export default CreateOnlyAction;
